import { ModalTypes } from 'enums/modalTypes';
import {
  ProjectPageGetProjectByIdDocument,
  RssAssessmentFragment,
  useDeleteAssessmentStageRssActionMutation,
} from 'generated/graphql';
import { closeModal, openModal } from 'graphql/modals';
import { FC, useState } from 'react';
import { NotificationModalProps } from 'views/ModalView/NotificationModal';
import {
  Button,
  NotificationModalType,
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';

interface IRemoveSkillsSelfAssessmentActionButton {
  rssAssessments: RssAssessmentFragment[];
  stageId: string;
  projectId: number;
}

const RemoveSkillsSelfAssessmentActionButton: FC<IRemoveSkillsSelfAssessmentActionButton> =
  ({ rssAssessments, stageId, projectId }) => {
    const [submitting, setSubmitting] = useState(false);
    const { handleMsgType } = useNotification();

    const [deleteRssAction] = useDeleteAssessmentStageRssActionMutation({
      refetchQueries: [
        { query: ProjectPageGetProjectByIdDocument, variables: { id: projectId } },
      ],
      onError: () => {
        handleMsgType({
          type: TNotification.error,
          message:
            'Oops, an error occurred while removing the Skills self-assessment action!',
        });
        setSubmitting(false);
      },
      onCompleted: () => {
        handleMsgType({
          type: TNotification.success,
          message: 'Skills self-assessment action removed!',
        });
        setSubmitting(false);
      },
    });

    const handleDelete = () => {
      const confirmationModalProps: NotificationModalProps = {
        message:
          'This action will remove "Skills self-assessment" from the stage',
        okButtonChildren: 'OK',
        type: NotificationModalType.WARNING,
        onOkClick: async () => {
          setSubmitting(true);
          closeModal(ModalTypes.NOTIFICATION_MODAL);
          for (const rssAssessment of rssAssessments) {
            await deleteRssAction({
              variables: {
                stageId,
                type: rssAssessment.type,
              },
            });
          }
        },
      };

      openModal(ModalTypes.NOTIFICATION_MODAL, confirmationModalProps);
    };

    return (
      <Button
        variant="secondary"
        size="small"
        className="remove-skills-self-assessment-action-button"
        onClick={handleDelete}
        disabled={submitting}
      >
        Remove
      </Button>
    );
  };

export default RemoveSkillsSelfAssessmentActionButton;
